import "../chunk-PKUHTIDK.js";
import { handleNavItemClick, getBoundRectNV, handleNavItemClose } from "./index";
const api = ["state", "handleNavItemClick", "getBoundRect", "handleNavItemClose"];
const renderless = (props, { inject, markRaw, reactive, computed }, { vm }) => {
  const tabs = inject("tabs", null);
  tabs.addNav(markRaw(vm));
  const state = reactive({
    tabSize: computed(() => tabs.size),
    withClose: computed(() => tabs.withClose)
  });
  const api2 = {
    state,
    handleNavItemClick: handleNavItemClick({ tabs, props }),
    getBoundRect: getBoundRectNV({ vm, props }),
    handleNavItemClose: handleNavItemClose({ tabs, props })
  };
  return api2;
};
export {
  api,
  renderless
};
